export default "__VITE_ASSET__Dbqt4_VD__"